import { NavLink } from "react-router-dom";

import { cn } from "@/lib/utils";

const tabs = [
  { to: "/tradeideas/status", label: "Status" },
  { to: "/tradeideas/scanners", label: "Scanners" },
  { to: "/tradeideas/filters", label: "Filters" },
  { to: "/tradeideas/delivery", label: "Delivery" },
];

export function TradeIdeasPage({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border px-6 py-4">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h1 className="text-xl font-semibold">{title}</h1>
            <p className="text-xs text-muted-fg">{description}</p>
          </div>
          <nav className="flex items-center gap-1 rounded-md border border-border bg-muted/20 p-1">
            {tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) =>
                  cn(
                    "rounded px-3 py-1.5 text-xs font-medium text-muted-fg hover:bg-muted hover:text-fg",
                    isActive && "bg-muted text-fg",
                  )
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-6">{children}</div>
    </div>
  );
}

export function TradeIdeasError({ message }: { message: string }) {
  return (
    <div className="rounded-md border border-red-500/30 bg-red-500/10 p-4 text-sm text-red-200">
      {message}
    </div>
  );
}

export function TradeIdeasEmpty({ message }: { message: string }) {
  return (
    <div className="rounded-md border border-border p-8 text-center text-sm text-muted-fg">
      {message}
    </div>
  );
}
